<app-page-header>Installation and recycling</app-page-header>

<div id="top">
  <div
    class="container container__additional-services xs-row"
    *ngIf="selected?.article_id"
  >
    <div class="page-header">
      <a
        routerLink="/product-details"
        queryParamsHandling="merge"
        class="link typog-body-large-bold"
        ><i class="fa-solid fa-arrow-left mr-1"></i>Back</a
      >
      <div class="replacement--title">
        <h3>
          <span>{{ selected?.make }}</span>
          <span> {{ selected?.appliance_category }}</span>
        </h3>
        <h5 class="mt-1">{{ selected?.model }}</h5>
      </div>
    </div>

    <app-selected-item
      [data]="selected"
      [costSummary]="costSummary$ | async"
    ></app-selected-item>

    <div class="xs-12--none md-12--none">
      <div class="additional-services-wrapper">
        <app-add-extras-container
          id="extras"
          [services]="selected?.services"
          [isInstallationSelected]="isInstallationSelected$ | async"
          [isDisposalSelected]="isDisposalSelected$ | async"
          [installation]="getInstallation$ | async"
          [disposal]="getDisposal$ | async"
          [delivery]="getDelivery$ | async"
          [deliveryDates]="deliveryDates$ | async"
          (continue)="continueClick()"
        >
        </app-add-extras-container>
      </div>
    </div>
  </div>
</div>

<app-upsell-extras-modal
  *ngIf="showUpsellModal && isUpsellAvailable$ | async"
  [@fadeInOut]
  [installationUpsellAvailable]="isInstallationUpsellAvailable$ | async"
  [disposalUpsellAvailable]="isDisposalUpsellAvailable$ | async"
  (clicked)="onUpsellModalResponse($event)"
>
</app-upsell-extras-modal>
